export const imageGroups = {
  general: 'general',
  backgrounds: 'backgrounds',
  returnsPortal: 'returnsPortal',
  tracking: 'tracking',
  emails: 'emails',
}
